<template>
  <div class="v-tour">
    <slot
      :current-step="currentStep"
      :steps="steps"
      :previous-step="previousStep"
      :next-step="nextStep"
      :stop="stop"
      :isFirst="isFirst"
      :isLast="isLast"
    >
      <!--Default slot {{ currentStep }}-->
      <transition name="fade" v-for="(step, index) of steps" :key="index">
        <v-step
          v-if="currentStep === index"
          :step="step"
          :previous-step="previousStep"
          :next-step="nextStep"
          :stop="stop"
          :isFirst="isFirst"
          :isLast="isLast"
        >
        </v-step>
      </transition>
    </slot>
  </div>
</template>

<script>
  import {DEFAULT_CALLBACKS, DEFAULT_OPTIONS, KEYS} from './constants';

  export default {
    name: 'v-tour',
    props: {
      steps: {type: Array, default: () => []},
      name: String,
      options: {type: Object, default: () => DEFAULT_OPTIONS},
      callbacks: {type: Object, default: () => DEFAULT_CALLBACKS},
    },
    data() {
      return {currentStep: -1};
    },
    mounted() {
      this.$tours[this.name] = this;
      if (this.customOptions.useKeyboardNavigation) {
        window.addEventListener('keyup', this.handleKeyup);
      }
    },
    beforeDestroy() {
      if (this.customOptions.useKeyboardNavigation) {
        window.removeEventListener('keyup', this.handleKeyup);
      }
    },
    destroyed() {
      delete this.$tours[this.name];
    },
    computed: {
      customOptions() {
        return {...DEFAULT_OPTIONS, ...this.options};
      },
      customCallbacks() {
        return {...DEFAULT_CALLBACKS, ...this.callbacks};
      },
      isRunning() {
        return this.currentStep >= 0 && this.currentStep < this.numberOfSteps;
      },
      isFirst() {
        return this.currentStep === 0;
      },
      isLast() {
        return this.currentStep === this.steps.length - 1;
      },
      numberOfSteps() {
        return this.steps.length;
      },
    },
    methods: {
      start(startStep) {
        setTimeout(() => {
          this.customCallbacks.onStart();
          this.currentStep = typeof startStep !== 'undefined' ? parseInt(startStep, 10) : 0;
        }, this.customOptions.startTimeout);
      },
      previousStep() {
        if (this.currentStep > 0) {
          this.customCallbacks.onPreviousStep(this.currentStep);
          this.currentStep--;
        }
      },
      nextStep() {
        if (this.currentStep < this.numberOfSteps - 1 && this.currentStep !== -1) {
          this.customCallbacks.onNextStep(this.currentStep);
          this.currentStep++;
        }
      },
      stop() {
        this.customCallbacks.onStop();
        this.currentStep = -1;
      },
      handleKeyup(e) {
        switch (e.keyCode) {
          case KEYS.ARROW_RIGHT:
            this.nextStep();
            break;
          case KEYS.ARROW_LEFT:
            this.previousStep();
            break;
          case KEYS.ESCAPE:
            this.stop();
            break;
        }
      },
    },
  };
</script>
